import { Injectable } from '@angular/core';
import { Notification, NotificationAction } from '@lycoris-nubila/ngx-lycoris';
import { BehaviorSubject, NextObserver, Observable, Subject } from 'rxjs';
import {
	distinctUntilChanged,
	filter,
	map,
	startWith,
	tap,
} from 'rxjs/operators';
import { WebSocketSubject, webSocket } from 'rxjs/webSocket';

import { NotificationDomain } from 'application/common/model/notification-domain';
import { AppPushApiPort } from 'application/common/port/app-push-api.port';
import { environment } from 'environments/environment';
import { UserSessionPort } from 'user/port/user-session.port';

@Injectable()
export class AppPushApiAdapter implements AppPushApiPort, NextObserver<Event> {
	private _wsSubject: WebSocketSubject<any>;
	private _wsObservable: Subject<Notification<NotificationDomain, null>>;
	private _wsConnected$ = new BehaviorSubject<boolean>(true);

	constructor(private _userSessionPort: UserSessionPort) {
		this._wsObservable = new Subject<Notification<NotificationDomain, null>>();
		this._buildWebSocket();
	}

	public next(event: Event): void {
		if (event.type === 'open') {
			this._wsSubject.next({
				jwt: this._userSessionPort.getJwToken(),
				action: 'authenticate',
			});
			this._wsConnected$.next(true);
		} else if (event.type === 'close') {
			setTimeout(() => {
				this._buildWebSocket();
				this._wsConnected$.next(false);
			}, 1000);
		} else {
			this._wsObservable.next(event as any);
		}
	}

	public observeWebsocketChanges(): Observable<boolean> {
		return this._wsConnected$.pipe(distinctUntilChanged());
	}

	public observeDomainMessage(
		domain: NotificationDomain
	): Observable<Notification<NotificationDomain, null>> {
		return this._wsObservable.pipe(
			filter((message) => message.domain === domain)
		);
	}

	private _buildWebSocket(): void {
		this._wsSubject = webSocket<any>({
			url: environment.websocketUrl,
			openObserver: this,
			closeObserver: this,
		});
		this._wsSubject.subscribe(this);
	}
}
